import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('europa');
const type = createActionType('europa');

export const REHYDRATE = type('Rehydrate');
export const SELECT_CELL = type('SelectCell');
export const SELECT_COLUMN_BY_NAME = type('SelectColumnByName');
export const ADD_USERS_TO_SPACE = apiType('AddUsersToSpace');
export const DELETE_USERS_FROM_SPACE = apiType('DeleteUsersFromSpace');
export const ADD_TAGS = apiType('AddTags');
export const REMOVE_TAGS = apiType('RemoveTags');
export const GET_TAGS = apiType('GetTags');
